import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { imagesTheme3 } from '../../../assets/tema3';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	dialogThirteen: 14,
	dialogFourteen: 15,
	dialogFifteen: 16,
	dialogSixteen: 17,
	dialogSeventeen: 18,
	dialogEighteen: 19,
	dialogNineteen: 20,
	dialogTwenty: 21,
	dialogTwentyOne: 22,
	dialogTwentyTwo: 23,
	dialogTwentyThree: 24,
	dialogTwentyFour: 25,
	dialogTwentyFive: 26,
	dialogTwentySix: 27,
	dialogTwentySeven: 28,
	dialogTwentyEight: 29,
	dialogTwentyNine: 30,
	dialogThirty: 31,
	dialogThirtyOne: 32,
	dialogThirtyTwo: 33,
	dialogThirtyThree: 34,
	dialogThirtyFour: 35,
	win: 36
};


const stepThree = {
	iluminat_zone: steps.dialogFive,
	view_spray: steps.dialogSix,
	iluminate_koaxka: steps.dialogNine,
	view_box: steps.dialogTen,
	go_food_fast: steps.dialogEleven,
	go_bread: steps.dialogTwelve,
	go_waste_bags: steps.dialogSixteen,
	go_room_cold: steps.dialogEighteen,
	go_desk: steps.dialogNineteen,
	ilumination_desk: steps.dialogTwenty,
	sausages: steps.dialogTwentyTwo,
	plant: steps.dialogTwentyFour,
	rang: steps.dialogTwentyFive,
	garbage_bag: steps.dialogTwentySix,
	go_back_init: steps.dialogTwentyNine,
};

const stepThreeAudio = {
	iluminat_zone: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a05T3)
		}
	},
	view_spray: {
		action: () => {

		}
	},
	iluminate_koaxka: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a09T3)
		}
	},
	view_box: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a10T3)
		}
	},
	go_food_fast: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a11T3)
		}
	},
	go_bread: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a12T3)
		}
	},
	go_waste_bags: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a16T3)
		}
	},
	go_room_cold: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a17T3)
		}
	},
	go_desk: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a18T3)
		}
	},
	ilumination_desk: {
		action: () => {

		}
	},
	sausages: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a21T3)
		}
	},
	plant: {
		action: () => {

		}
	},
	rang: {
		action: () => {

		}
	},
	garbage_bag: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a25T3)
		}
	},
	go_back_init: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a28T3)
		}
	},
};


export const Theme3SubtopicThreeActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema3], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 3 act 1");
			ObserverEmitter.emit(EVENTS.tema3.topic3.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.topic2.actOne.finishMoveAnimation, (step = "") => {
		const stepSelect = stepThree[step]
		if (!stepSelect) {
			return
		}
		setUiToShow(stepSelect)

		const stepAudio = stepThreeAudio[step]
		stepAudio.action()
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic3.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Inocuidad Limpieza" />
					<DialogBarNew
						dialog={`Es momento de hablar sobre algunos conceptos claves en nuestra Tienda: la Inocuidad, la limpieza y la merma. Estos se encuentran dentro de nuestras actividades diarias.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Inocuidad "
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a02T3)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Hablemos de la Inocuidad: la cual nos habla de la garantía de nuestros productos, garantizando que no causarán daño al consumidor cuando sea ingerido, es nuestro sello de calidad.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a03T3)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<CircleColors />
					<DialogBarNew
						dialog={`Veamos cuáles son los Cinco pilares de la Inocuidad.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a04T3)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<CircleColors type={1} />
					<DialogBarNew
						dialog={`¡Comenzaremos con la Limpieza!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "iluminat_zone")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`1.- Mantén libre de contaminantes las superficies, los utensilios y los equipos de la Tienda.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a06T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "view_spray")
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`2.- Los químicos e insumos son exclusivos para esta tarea.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a07T3)
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`3.- Esta tarea debe ser asignada diariamente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a08T3)
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<CircleColors type={1} />
					<DialogBarNew
						dialog={`¡Continuemos con "Control de temperatura"!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "iluminate_koaxka")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`1.- Productos refrigerados: el Koxka y el Salchikoxka deben indicar un máximo de 7°C.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "view_box")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Al llegar productos de CEDIS, llévalos de inmediato al Cuarto Frío o colócalos en el Koxka.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "go_food_fast")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<DialogBarNew
						dialog={`2.- Productos congelados: deben ser llevados inmediatamente al congelador, si el producto llega a descongelarse no podrá congelarse nuevamente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "go_bread")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwelve && (
				<>
					<DialogBarNew
						dialog={`3.- Productos calientes: recuerda mantener la perilla en el nivel que indica tu guía operativa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a13T3)
							setUiToShow(steps.dialogThirteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirteen && (
				<>
					<DialogBarNew
						dialog={`4.- Si uno de tus equipos no funciona correctamente, repórtalo en ATL de inmediato.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a14T3)
							setUiToShow(steps.dialogFourteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFourteen && (
				<>
					<CircleColors type={1} />
					<DialogBarNew
						dialog={`¡Sigamos adelante con control de plagas!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a15T3)
							setUiToShow(steps.dialogFifteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFifteen && (
				<>
					<DialogBarNew
						dialog={`1.- Se recibirán visitas periódicas del fumigador, dependiendo del tipo de tienda.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "go_waste_bags")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSixteen && (
				<>
					<DialogBarNew
						dialog={`2.- Manejo correcto de residuos: coloca la basura en su lugar y evita dejar mermas a la vista. Si hay algún derrame, límpialo lo antes posible.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "go_room_cold")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEighteen && (
				<>
					<DialogBarNew
						dialog={`3.- Ordena y limpia la bodega, realiza la rotación correcta de la mercadería y evita la acumulación de cajas, las cajas pueden ser refugios para ciertas plagas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "go_desk")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNineteen && (
				<>
					<DialogBarNew
						dialog={`4.- Cualquier desperfecto en la construcción deberá ser reportado de inmediato en ATL.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a19T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "ilumination_desk")
							setUiToShow(steps.dialogTwenty);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwenty && (
				<>
					<DialogBarNew
						dialog={`5.- Las puertas de entrada y bodega deben estar cerradas y asegúrate que los equipos de luz estén encendidos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a20T3)
							setUiToShow(steps.dialogTwentyOne);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyOne && (
				<>
					<CircleColors type={1} />
					<DialogBarNew
						dialog={`¡Excelente! vas muy bien continuemos con, buenas practicas en el manejo de alimentos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "sausages")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyTwo && (
				<>
					<DialogBarNew
						dialog={`1.- Lávate las manos antes de manipular alimentos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a22T3)
							setUiToShow(steps.dialogTwentyThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyThree && (
				<>
					<DialogBarNew
						dialog={`2.- Evita dejar los alimentos a la intemperie, deben ir dentro de su empaque o contenedor.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a23T3)
							setUiToShow(steps.dialogTwentyFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyFour && (
				<>
					<DialogBarNew
						dialog={`3.- Evita usar los utensilios o productos que no sean suministrados por OXXO.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a24T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "rang")
							setUiToShow(steps.dialogTwentyFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyFive && (
				<>
					<DialogBarNew
						dialog={`4.- Contamos con trapos de limpieza que son exclusivas para el área de alimentos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "garbage_bag")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentySix && (
				<>
					<DialogBarNew
						dialog={`5.- Las bolsas de basura y merma deben estar cerradas con un nudo, evitemos a toda costa las rasgaduras de la bolsa ya que podemos causar derrames.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a26T3)
							setUiToShow(steps.dialogTwentySeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentySeven && (
				<>
					<DialogBarNew
						dialog={`Y para finalizar; todo producto caduco debe ser retirado diariamente de la tienda.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a27T3)
							setUiToShow(steps.dialogTwentyEight);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyEight && (
				<>
					<CircleColors type={1} />
					<DialogBarNew
						dialog={`¡Es momento de revisar el último punto! "Atención a la Autoridad".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene, "go_back_init")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyNine && (
				<>
					<DialogBarNew
						dialog={`1.- Recibe y atiende las visitas que haga la Autoridad en la Tienda. Toda visita de Autoridad debe ser reportada en ATL y a tu Asesor.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a29T3)
							setUiToShow(steps.dialogThirty);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirty && (
				<>
					<div className='fixed z-30 w-full h-[100%] flex justify-center items-center' >
						<img className='h-full w-full object-contain' src={imagesTheme3.topic3.Certificado_Artboard02} alt="certificado" />
					</div>
					<DialogBarNew
						dialog={`2.- En el transcurso de la visita dales todo el apoyo requerido, y asegúrate de contar con tus licencias, permisos y reportes de fumigación guardados y a la mano.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a30T3)
							setUiToShow(steps.dialogThirtyOne);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirtyOne && (
				<>
					<DialogBarNew
						dialog={`3.- En caso de muestreo de alimentos, asegúrate de resguardar las muestras que deje la Autoridad. Si son alimentos preparados, refrigera y entrega posteriormente a tu Asesor.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_1.sub3_act1_a31T3)
							setUiToShow(steps.dialogThirtyTwo);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirtyTwo && (
				<>
					<DialogBarNew
						dialog={`Hay que poner cuidado en la Inocuidad puesto que es un requisito normativo, la Secretaría de Salud lo vigila y exige.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actOne.actScene)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Cada aspecto visto dentro de este módulo va a ser de gran ayuda para ti y para la tienda."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema3
								})
							);
							navigator("/home3/tema3/subtema3/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}


const CircleColors = ({ type = 0 }) => {
	let selectStylePosition = "left-[10%] -translate-x-[10%] md:top-1/2 md:-translate-y-1/2"
	if (type === 1) {
		selectStylePosition = "left-[50%] -translate-x-[50%] top-1/2 -translate-y-1/2"
	}
	return (
		<div className={`fixed z-30 xl:w-[500px] xl:h-[500px]  w-[272px] h-[272px] md:h-[400px] md:w-[400px] ${selectStylePosition}`}>
			<img className='h-full w-full object-contain' src={imagesTheme3.topic3.circuloColores} alt="circulo" />
		</div>
	)
}